import { useContextoApp } from "@/app/contexto";
import { useApiResource } from "@/hooks/useApiResource";
import type { CuentaDetalle } from "@/lib/api";

/** Lógica de la cuenta corriente de un fiduciante (sin JSX). Admin y contador; sólo lectura. */
export function useCuentaTab(fiducianteId: number) {
  const { fid } = useContextoApp();
  const cuenta = useApiResource<CuentaDetalle>(`/api/fideicomisos/${fid}/cuentas/${fiducianteId}`);
  return {
    cargando: !cuenta.data && cuenta.loading,
    noExiste: cuenta.error?.status === 404,
    errorCarga: !cuenta.data && cuenta.error && cuenta.error.status !== 404 ? cuenta.error.message : null,
    reintentar: cuenta.recargar,
    cuenta: cuenta.data ?? null,
  };
}
